import { FunctionComponent } from 'react'
import styled, { DefaultTheme } from 'styled-components'

import Loader from './Loader'

interface ILoadingBoxProps {
  aspectRatioPct?: number
  height?: number
  noBackground?: boolean
  tabletHeight?: number
}

const getTabletHeight = (props: ILoadingBoxProps & { theme: DefaultTheme }) => {
  let result

  const { headerHeight } = props.theme.metrics
  const { height, tabletHeight } = props

  if (tabletHeight) result = `${tabletHeight}px`
  else if (height) result = `min(calc(100vh - ${headerHeight}px), ${height}px)`
  else result = '100%'

  return result
}

const Container = styled.div<ILoadingBoxProps>`
  width: 100%;
  height: ${props =>
    props.height
      ? `min(calc(100vh - ${props.theme.metrics.headerHeightPhone}px), ${props.height}px)`
      : '100%'};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  background: ${props => props.theme.colors.transparentWhiteAlpha50};

  ${props => props.noBackground && `background: ${props.theme.colors.transparent};`}

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    height: ${getTabletHeight};
  }

  ${props =>
    props.aspectRatioPct
    && `
    ::before {
      content: "";
      display: inline-block;
      height: 0;
      padding-bottom: ${props.aspectRatioPct}%;
    }
  `}
`

const LoadingBox: FunctionComponent<ILoadingBoxProps> = props => {
  const { aspectRatioPct, height, noBackground, tabletHeight } = props

  return (
    <Container
      aspectRatioPct={aspectRatioPct}
      height={height}
      noBackground={noBackground}
      tabletHeight={tabletHeight}
    >
      <Loader height={height} />
    </Container>
  )
}

export default LoadingBox
